<template>
  <div class="mdc-drawer-app-content">
    <slot />
  </div>
</template>

<script>
import { baseComponentMixin, themeClassMixin } from "../base";

export default {
  mixins: [baseComponentMixin, themeClassMixin]
};
</script>

<style scoped></style>
